import isResultFromArchiveFanout from './isResultFromArchiveFanout';
import type { ClientItemId } from 'owa-client-ids';
import type { ConversationType } from 'owa-graph-schema';
import type { TableView } from 'owa-mail-list-store';
import getMailboxInfo from 'owa-mail-mailboxinfo/lib/getMailboxInfo';
import { getMailboxInfoForAuxArchive } from 'owa-mailbox-info/lib/getMailboxInfoForAuxArchive';
import { getStore } from '../store/store';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

export default function getConversationClientIdForSearchResult(
    conversationType: ConversationType,
    tableView: TableView
): ClientItemId {
    if (
        conversationType?.MailboxGuids &&
        isResultFromArchiveFanout(conversationType.MailboxGuids)
    ) {
        const { selectedMailboxInfo } = getStore();
        const mailboxInfo = getMailboxInfoForAuxArchive(
            selectedMailboxInfo ?? getModuleContextMailboxInfo(),
            conversationType.MailboxGuids[0]
        );

        return {
            Id: conversationType.ConversationId.Id,
            mailboxInfo,
        };
    } else {
        return {
            Id: conversationType.ConversationId.Id,
            mailboxInfo: conversationType.ConversationId.mailboxInfo ?? getMailboxInfo(tableView),
        };
    }
}
